export default "__VITE_ASSET__ujaEwBrK__"